<section class="banner">
    <app-mini-env-banner [slides]="bannerSlides" (butonAction)="onSliderBtnAction()"></app-mini-env-banner>
</section>  


<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block
        [miniTitle]="'Benefits Overview'"
        [title]="'Up to 80% discount on your healthcare needs!'"
        [description]="'WoW Health is a single door to access all type of healthcare providers. We are your next neighborhood.'"
        [style]="'max-width: 703px;'"
        [discription]="'max-width: 541px;'"
        ></app-mini-env-heading-block>

    <app-mini-env-benefit-cards [services]="services"></app-mini-env-benefit-cards>

  </div>
</section>

<section id="membership-section" class="container-fluid membershipplans-section membership-section">
  <div class="container">
    <div class="row basic-section-gap" style="flex-direction: row;">
      <div class="col-md-12">
        <app-mini-env-heading-block
            [miniTitle]="'Affordable Healthcare solution for you!'"
            [title]="'Healthcare access with membership,no insurance needed'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>
      </div>
      <div class="col-md-12">
        <app-membership-plan
            class="whata-burger-plane"
            [label]="('MEMBERSHIP.LABEL' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note1]="('MEMBERSHIP.NOTE1' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note2]="('MEMBERSHIP.NOTE2' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note3]="('MEMBERSHIP.NOTE3' | translateIt: {language: sharedService.currentLanguage} | async)"
            [membershipPlanCode]="membershipPlanCode"
             [isDiscounted]="true"
             [ngClass]="{'discount-class': isDiscounted}"
            [btnLabel]="'Select Membership'"></app-membership-plan>
      </div>

    </div>
  </div>
</section>

<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="('BENIFITSMEMBERSHIP.MINI_TITLE' | translateIt: {language: sharedService.currentLanguage} | async)"
    [title]="'Getting Started to Avail Your WoW Benefits Is Super Easy!'"
    [description]="'Follow these simple steps to start your WoW Health journey today.'"
    [style]="'max-width: 738px;'"
    ></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [imgLink]="sharedService.imagesUrl + 'woman-wave-phone.webp'"></app-imagebox-bullet-scroll>
</section>

<!-- <section>
  <div class="container-fluid video-section">

     <app-mini-env-heading-block
    [miniTitle]="'See WoW Health in Action'"
    [title]="'Let’s Dive Deep Into Understanding Wow Health'"
    [description]="'Heres a detailed video about how we make helathcare trustworthy for our WoW members'"
    [style]="'max-width: 749px;'"
    ></app-mini-env-heading-block>

    <div class="container">
      <app-video-player></app-video-player>
    </div>
  </div>
</section> -->


<section class="container-fluid faq-section">
  <div class="container">
    
    <app-mini-env-heading-block
    [miniTitle]="'FAQs'"
    [title]="'Frequently Asked Questions'"
    [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
    [style]="'max-width: 720px;'"
    ></app-mini-env-heading-block>

    <div class="mt-30">
       <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>  
<section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>  
</section>
<!--  How can we help Section End-->